import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import {HISTORY_ICON,CALENDER_ICON } from "assets/constants/Icons";
import { APP_NAME , TYPE_SUCCESS, INTERVAL} from 'assets/constants/Constants';
import MaterialTable from "material-table";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { getUserDetails, getUserCreditUsageList, getUserPaymentTranactionList, updateUserCredit, createAuditLogCall } from "lib/axiosUtils";
import "./user-style.css";
import moment from 'moment';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Button
  } from "@mui/material";
import ResetPasswordComponent from 'components/ResetPasswordComponent';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getRequiredCredit, updateUserSessionData } from 'lib/utils';
import ShowToast from 'components/ShowToast';

const CreditUsagePage = () => {
    const history = useHistory();
    const [logList, setLogList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [creditList, setCreditList] = useState([]);
    const [transactionList, setTransactionList] = useState([]);
    const userDetail = JSON.parse(localStorage.getItem("userData"));
    const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
    const [userData, setUserData] = useState(null);
    
    useEffect(() => {
    const fetchUserList = async () => {
        try {
            const data = await getUserDetails({}, {},userDetail._id);
            localStorage.setItem("userData",null);
            localStorage.setItem("userData", JSON.stringify(data.data.result));
            setUserList(data.data.result);
        }
        catch (error) {
            console.log("error while fetching data", error);
        }
    }
        fetchUserList();
    },[userDetail._id]);

    useEffect(() => {
    const fetchLogList = async () => {
        try {
            const data = await getUserCreditUsageList({}, {},userDetail._id);
            if (data?.data?.result && Object.entries(data.data.result).length > 0) {
                setCreditList(data.data.result);
                setLogList(data.data.result?.records);              
            }
        }
        catch (error) {
            console.log("error while fetching data", error);
        }
    }
        fetchLogList();
    },[userDetail._id]);

    useEffect(() => {
    const fetchTransactionList = async () => {
        let data;
        try {
            data = await getUserPaymentTranactionList({}, {},userDetail._id);
            setTransactionList(data.data.result);
        }
        catch (error) {
            console.log("error while fetching data", error);
        }
    }
        fetchTransactionList();
    },[userDetail._id]);

    const resetPasswordHandler = (rowData) => {
        const tempUserData = {
            ...rowData,
            userId: rowData._id
        }
        setUserData(tempUserData);
        setOpenResetPasswordModal(true);
    };
    
    const cancelHandle = () => {
        setOpenResetPasswordModal(false);
        setUserData(null);
    };

    const creditTopup = () => {
        history.push({
            pathname: '/payment/pay',
            state: {redirectedFrom: 'CreditUsagePage'} 
        });
    }

    const downloadInvoice = async (rowData) => {
        const moduleName = "Download Invoice";
        try {
            const requiredCredit = await getRequiredCredit(userDetail.region_id, moduleName);
            if (userDetail.total_credit > requiredCredit) {
                if (window.confirm(`This action will deduct ${requiredCredit} credits. Are you sure you want to continue?`)) {
                    const doc = new jsPDF("p", "pt", "a4");
                    const pageWidth = doc.internal.pageSize.getWidth();

                    const contentWidth = 350; // your chosen invoice block width
                    const startX = (pageWidth - contentWidth) / 2; // <-- center align block

                    // Draw border
                    doc.setDrawColor(0);
                    doc.rect(startX, 40, contentWidth, 500);

                    // Header
                    doc.setFontSize(18);
                    doc.setFont("helvetica", "bold");
                    doc.text(APP_NAME, pageWidth / 2, 70, { align: "center" });

                    doc.setFontSize(12);
                    doc.setFont("helvetica", "normal");

                    // Divider line inside border
                    doc.line(startX + 20, 100, startX + contentWidth - 20, 100);

                    // Merchant Info
                    doc.setFontSize(10);
                    // doc.text("Million AI Pvt Ltd", startX + 20, 120);
                    doc.text(`Transaction Id: ${rowData.transactionId}`, startX + 20, 135);

                    // Transaction details
                    doc.text(`Date: ${rowData.date}`, startX + 20, 155);
                    // doc.text("Time: 13:11:25", startX + 200, 155);
                    doc.text(
                      `Invoice No: INV-${Math.floor(Math.random() * 10000)}`,
                      startX + 20,
                      170
                    );
                    doc.text(`Method: ${rowData.method}`, startX + 200, 170);

                    // SALE heading
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(14);
                    // doc.text("SALE", pageWidth / 2, 200, { align: "center" });

                    // User Info
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(11);
                    doc.text(`User: ${rowData.user}`, startX + 20, 225);
                    doc.text(`Notes: ${rowData.notes}`, startX + 20, 245);
                    doc.text(`Status: ${rowData.status}`, startX + 20, 265);

                    // Amount
                    doc.setFont("helvetica", "bold");
                    doc.text(`BASE AMOUNT: Rs.${rowData.amount}`, startX + 20, 300);

                    // Footer
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(10);
                    doc.text("SIGNATURE NOT REQUIRED", startX + 20, 330);
                    doc.text("I agree to pay as per the card issuer agreement.", startX + 20, 350);

                    doc.setFont("helvetica", "bold");
                    doc.text("***** CUSTOMER COPY *****", pageWidth / 2, 380, { align: "center" });

                    doc.setFontSize(12);
                    doc.text(`Powered by ${APP_NAME}`, pageWidth / 2, 420, { align: "center" });

                    doc.save(`invoice_${rowData.user}.pdf`);

                    const userParams = {
                        updateCredit: requiredCredit,       
                    };
                    const auditParams = {
                        moduleName: moduleName,
                        userID: userDetail._id,
                        creditUsed: requiredCredit,
                        logText: `Credits Used for ${moduleName}`,
                        fileType: "pdf"
                    };
                    const updateDataPromise = await Promise.all([
                        updateUserCredit({}, userParams, userDetail._id),
                        createAuditLogCall({}, auditParams)
                    ])

                    if (updateDataPromise && updateDataPromise[0] && updateDataPromise[0].statusCode === 200) {
                        await updateUserSessionData(userDetail);
                        window.location.reload();
                    }
                }
            } else {
                ShowToast("You can't do this opertaion, as You do not have required credit.", TYPE_SUCCESS, INTERVAL, "", "");
            }
        }
        catch (error) {
            console.log("Error occurre", error);
        }
    };

    const mytheme= createTheme({});
    return (<>
    {
       (
        <div className="main-content">
            <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
                <div className="col-md-10 sm_device"><i className={`${HISTORY_ICON}`}></i> Profile information</div>
                <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
            </div>
            <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
            <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2 }}>
                <Table>
                    <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: "bold", fontSize: 15 }}>User</TableCell>
                        <TableCell sx={{ fontWeight: "bold", fontSize: 15 }}>Email Id</TableCell>
                        <TableCell sx={{ fontWeight: "bold", fontSize: 15 }}>Password</TableCell>
                        <TableCell sx={{ fontWeight: "bold", fontSize: 15 }}>Actions</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {/* {userList.map((item) => ( */}
                        <TableRow key={userList._id}>
                        <TableCell sx={{ fontWeight: "bold", fontSize: 14 }}>
                            {userList.first_name} {userList.last_name}
                        </TableCell>
                        <TableCell sx={{ fontSize: 14, color: "#808080" }}>
                            {userList.email_id}
                        </TableCell>
                        <TableCell sx={{ fontSize: 14, color: "#808080" }}>
                            {/* Mask password with same number of asterisks */}
                            {userList.password ? "*".repeat(userList.password.length) : "******"}
                        </TableCell>
                        <TableCell>
                            <Button
                            variant="outlined"
                            size="medium"
                            onClick={() => resetPasswordHandler(userList)}
                            >
                            Reset Password
                        </Button>
                        </TableCell>
                        </TableRow>
                    {/* ))} */}
                    </TableBody>
                </Table>
            </TableContainer>

            {openResetPasswordModal && (
                <ResetPasswordComponent modelOpen={openResetPasswordModal} closeModel={cancelHandle} cancelHandle={cancelHandle}  userData={userData}
                />
            )}

            <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
                <div className="col-md-10 sm_device"><i className={`${HISTORY_ICON}`}></i> Credit Usage</div>
            </div>
            <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
            <div className="help-support-contact-wrapper">
                <div className="credit-usage-div">
                <div className="help-support-contact-inner-div">
                    <label>Total Credits: </label>&nbsp; 
                    {
                        userDetail?.total_credit
                    }
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                    <label className="ml-5">Avg Credits used in last 30 days: </label>&nbsp;
                    {
                        creditList?.avgLast30Days
                    }
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                    <label className="ml-5">Avg Credits used per day: </label>&nbsp;
                    {
                        creditList?.avgPerDay
                    }
                </div>
                </div> 
                <button className="brand-button ml-5" onClick={(e) => creditTopup()}>TopUp Credits</button>

            </div>
            <div className="list-wrapper">
                <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
                    {
                        true ? (
                            <ThemeProvider theme={mytheme}>
                                <MaterialTable
                                    columns={[
                                        {
                                            title: "Date", field: "date",
                                            cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                        },
                                        {
                                            title: "Module Name", field: "module_name",
                                            cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                        },
                                        {
                                            title: "Details", field: "details",
                                            cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                            sorting: false
                                        },
                                        {
                                            title: "Credits Used", field: "credit_used",
                                            cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                            sorting: false
                                        }
                                    
                                    ].filter(Boolean)}
                                    data={
                                        logList.map((item) => {
                                            return (
                                                {
                                                    date: new Date(item.created_date_time).toLocaleDateString('en-IN', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        second: '2-digit',
                                                        hour12: false 
                                                    }),
                                                    module_name: item.module_name,
                                                    details: item.log_text,  
                                                    credit_used: item.credit_used                                   
                                                }
                                            )
                                        })
                                    }

                                    options={{
                                        actionsColumnIndex: -1,
                                        headerStyle: {
                                            color: '#999998',
                                            fontWeight: 'bolder',
                                            fontSize: 15
                                        },
                                        filtering: true,
                                        sorting: true,
                                        columnsButton: true,
                                        exportButton: true,
                                        exportFileName: "History Page Data"
                                    }}
                                />
                            </ThemeProvider>
                        ) : (
                            <div className="text-center pt-2">
                                <label>Not Found</label>
                            </div>
                        )

                    }
                </div>
            </div>
            <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
            <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
                <div className="col-md-10 sm_device"><i className={`${HISTORY_ICON}`}></i> Billing info </div>
            </div>
            <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
            <div className="list-wrapper">
                <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
                    {
                    true ? (
                            <ThemeProvider theme={mytheme}>
                                <MaterialTable
                                    columns={[
                                        {
                                            title: "User", field: "user",
                                            cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                        },
                                        {
                                            title: "Amount", field: "amount",
                                            cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14, textTransform: 'none' }
                                        },
                                        {
                                            title: "Notes", field: "notes",
                                            cellStyle: { cellWidth: '18%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                        },
                                        {
                                            title: "Method", field: "method",
                                            cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                            sorting: false
                                        },
                                        {
                                            title: "Status", field: "status",
                                            cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14, textTransform: 'none' }
                                        },
                                        {
                                            title: "Date", field: "date",
                                            cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                        }
                                    
                                    ].filter(Boolean)}
                                    data={
                                    transactionList.map((item) => {
                                        return ({
                                            user: item.full_name? item.full_name : `${userDetail.first_name} ${userDetail.last_name}`,
                                            amount: item.amount,  
                                            notes:item.notes,
                                            method:item.payment_method,
                                            status:item.payment_status,
                                            date: new Date(item.updated_date_time).toLocaleDateString('en-IN', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false 
                                            }), 
                                            transactionId: item.transaction_id,
                                            orderId: item.order_id,
                                            currency: item.currency,

                                        })
                                    })
                                }actions={[
                                    {
                                        icon: () => (
                                          <button className="download-invoice-button">
                                            Download Invoice
                                          </button>
                                        ),
                                        tooltip: "Download Invoice",
                                        onClick: (event, rowData) => downloadInvoice(rowData),
                                    }
                                    
                                ].filter(Boolean)}
                                    options={{
                                        actionsColumnIndex: -1,
                                        headerStyle: {
                                            color: '#999998',
                                            fontWeight: 'bolder',
                                            fontSize: 15
                                        },
                                        filtering: true,
                                        sorting: true,
                                        columnsButton: true,
                                        exportButton: true,
                                        exportFileName: "History Page Data"
                                    }}
                                />
                            </ThemeProvider>
                        ) : (
                            <div className="text-center pt-2">
                                <label>Not Found</label>
                            </div>
                        )
                    }
                </div>
            </div>    
        </div>
      )
    }
  </>);
}

export default CreditUsagePage;